import React, { useCallback, useEffect, useRef, useState } from 'react';
import EditarCampanaForm from './EditarCampanaForm';
import Progreso from './Progreso';
import { cancelarCampana, detalleCampana } from './campanasApi';
import { F, L } from './estilos';
import { ESTADOS_CAMPANA, fechaLocal, mensajeDeProblema, textoCabecera } from '../../utils/campanas';

/** Detalle de una campaña: cifras, editar y cancelar si está programada. Los destinatarios no se listan. */
const DetalleCampana = ({ campanaId, onVolver, onSuccess, onError }) => {
  const [campana, setCampana] = useState(null);
  const [editando, setEditando] = useState(false);
  const [confirmando, setConfirmando] = useState(false);
  const avisos = useRef({ onSuccess, onError });
  avisos.current = { onSuccess, onError };
  const cancelando = useRef(false);
  const solicitud = useRef(0);

  const cargar = useCallback(async () => {
    const marca = ++solicitud.current;
    const detalle = await detalleCampana(campanaId);
    if (marca !== solicitud.current) return;
    if (detalle.ok) setCampana(detalle.data);
    else avisos.current.onError(mensajeDeProblema(detalle.data, 'No se pudo cargar la campaña.'));
  }, [campanaId]);

  useEffect(() => { cargar(); }, [cargar]);

  const cancelar = async () => {
    if (cancelando.current) return;
    cancelando.current = true;
    setConfirmando(false);
    const r = await cancelarCampana(campanaId);
    cancelando.current = false;
    if (r.ok) {
      setCampana(r.data);
      avisos.current.onSuccess('Campaña cancelada');
    } else {
      avisos.current.onError(mensajeDeProblema(r.data, 'No se pudo cancelar la campaña.'));
    }
  };

  const guardada = (actualizada) => {
    setCampana(actualizada);
    setEditando(false);
    avisos.current.onSuccess('Campaña actualizada');
    cargar();
  };

  const programada = campana?.estado === 'PROGRAMADA';
  const lineaCabecera = campana ? textoCabecera(campana.cabeceraFormato, campana.cabeceraNombre) : null;

  return (
    <div className="campanas">
      <div className="campanas-tarjeta" style={L.tarjeta}>
        <div className="campanas-cabecera" style={L.cabecera}>
          <div>
            {campana && (
              <>
                <div style={L.acciones}>
                  <h3 style={L.titulo}>{campana.nombre}</h3>
                  <span style={L.estado(campana.estado)}>{ESTADOS_CAMPANA[campana.estado]}</span>
                </div>
                <p className="campanas-texto" style={L.meta}>
                  {`${fechaLocal(campana.programadaParaLocal)} (${campana.zonaHoraria})`
                    + ` · ${campana.templateName} (${campana.languageCode})`}
                </p>
                {lineaCabecera && <p style={L.meta}>{lineaCabecera}</p>}
              </>
            )}
          </div>
          <div className="campanas-acciones" style={L.acciones}>
            {programada && !editando && (
              confirmando ? (
                <>
                  <span style={L.confirmacion}>¿Cancelar la campaña?</span>
                  <button type="button" style={L.btnPeligro} onClick={cancelar}>Sí, cancelar</button>
                  <button type="button" style={F.btnGhost} onClick={() => setConfirmando(false)}>No</button>
                </>
              ) : (
                <>
                  <button type="button" style={F.btnSmall} onClick={() => setEditando(true)}>Editar</button>
                  <button type="button" style={L.btnPeligro} onClick={() => setConfirmando(true)}>Cancelar campaña</button>
                </>
              )
            )}
            <button type="button" style={F.btnGhost} onClick={onVolver}>Volver</button>
          </div>
        </div>
        {campana && (
          <>
            {campana.motivoFallo && <div style={F.banner('error')}>{campana.motivoFallo}</div>}
            <Progreso campana={campana} detallado />
            {programada && editando && (
              <EditarCampanaForm
                campana={campana}
                onGuardada={guardada}
                onError={(m) => avisos.current.onError(m)}
                onCancelar={() => setEditando(false)}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DetalleCampana;
